<template>
    <div>
        <div class="pa-16">
            <p>
            <div class="text-h4 font-weight-light">Privacy Statement</div>
            </p>
            <br>
            <p class="body-content">
                This is the Privacy Policy for the Dell Technologies Performance Portal, a Rewards and Recognition
                incentive platform through which we promote participation by partner and distributors in incentive
                programs relating to the sales and growth of Dell Technologies products and services.
            </p>
            <br>
            <p class="ml-2 mr-10 float-left">
                <v-card elevation="3" outlined width="250">
                    <ul style="list-style:none; margin-left: 0;">
                        <li class="list-item-border">
                            <a class="list-item-anchor" href="#section1">
                                1. About this privacy policy
                            </a>
                        </li>
                        <li class="list-item-border">
                            <a class="list-item-anchor" href="#section2">
                                2. Information you provide
                            </a>
                        </li>
                        <li class="list-item-border">
                            <a class="list-item-anchor" href="#section3">
                                3. Information we collect about you.
                            </a>
                        </li>
                        <li class="list-item-border">
                            <a class="list-item-anchor" href="#section4">
                                4. Information we receive from other sources
                            </a>
                        </li>
                        <li class="list-item-border">
                            <a class="list-item-anchor" href="#section5">
                                5. How and why we use your information
                            </a>
                        </li>
                        <li class="list-item-border">
                            <a class="list-item-anchor" href="#section6">
                                6. Disclosure of Your Information
                            </a>
                        </li>
                        <li class="list-item-border">
                            <a class="list-item-anchor" href="#section7">
                                7. Where We Store Your Personal Data
                            </a>
                        </li>
                        <li class="list-item-border">
                            <a class="list-item-anchor" href="#section8">
                                8. How long we store your information for
                            </a>
                        </li>
                        <li class="list-item-border">
                            <a class="list-item-anchor" href="#section9">
                                9. Cookies
                            </a>
                        </li>
                        <li class="list-item-border">
                            <a class="list-item-anchor" href="#section10">
                                10. How long we store your information for
                            </a>
                        </li>
                        <li class="list-item-border">
                            <a class="list-item-anchor" href="#section11">
                                11. Changes to Our Privacy Policy
                            </a>
                        </li>
                        <li class="list-item-border">
                            <a class="list-item-anchor" href="#section12">
                                12. Contact
                            </a>
                        </li>
                    </ul>
                </v-card>
            </p>
            <ol>
                <li class="list-header">
                    <div id="section1">About this privacy policy</div>
                    <div class="list-content">

                        <p>
                            The Dell Technologies Performance Portal works by providing individual users with Reward
                            Points for participating in various activities. Rewards Points can be exchanged for rewards.
                        </p>
                        <br>
                        <p>
                            In order to provide you with access to the Dell Technologies Performance Portal, we need to
                            use and store your information. Please read this Policy carefully to understand our views
                            and practices regarding your personal information and how we will treat it. In addition to
                            this Privacy Policy you need to review the Terms of Use upon login as you will be bound by
                            those terms when using the Dell Technolgies Performance Portal.
                        </p>
                        <br>
                        <p>
                            For the purpose of data protection law, Dell Technologies is the controller of your personal
                            information (this means we make decisions about how and why your information is used, and
                            have a duty to ensure your rights are protected). If you have questions or concerns about
                            this policy, you should contact us directly by emailing privacy@dell.com
                        </p>
                        <br>
                        <p>
                            The Dell Technologies Performance Portal and https://www.dellpartnerincentives.com/ (the
                            “Website”) are both operated on our behalf by The Incentive Company (TIC) of 1, Vantage
                            Court, Newport Pagnell, Buckinghamshire MK16 9EZ. TIC is acting as a data processor for the
                            purposes of data protection law (this means TIC will only use your information on our
                            instructions and in accordance with a written contract that ensures your rights are
                            protected).
                        </p>
                    </div>

                </li>
                <li class="list-header">
                    <div id="section2">Information you provide</div>
                    <div class="list-content">
                        <p>
                            We will collect and use personal information that you provide to us in connection with the
                            Dell Technologies Performance Portal. If you provide details of your activities in order to
                            earn Rewards, then we will collection information about those activities. We also collect
                            information when you:
                        </p>
                        <br>
                        <ul>
                            <li>
                                fill in forms, communicate with us by phone, e-mail or otherwise
                            </li>
                            <li>
                                register to use the Dell Technologies Performance Portal or our website
                            </li>
                            <li>
                                enters details of activities completed in connection with Dell Technologies Performance
                                Portal
                            </li>
                            <li>
                                place an order using our Rewards Scheme
                            </li>
                            <li>
                                enter a competition, promotion or survey
                            </li>

                        </ul>
                        <br>
                        <p>
                            The information we collect in this manner will usually include your name, address, e-mail
                            address, and phone number. The Dell Technologies Performance Portal is continually being
                            improved and developed and as such further information may need to be collected from you
                            from time to time. You will be notified of any further information required and the reason
                            behind this when visiting the site. You will always retain the right not to have to provide
                            any information requested from you.
                        </p>
                        <br>
                        <p>
                            We don’t normally ask for (or otherwise collect) sensitive personal information about you.
                            In the unlikely event that we do, we’ll ensure that such information is kept private and
                            secure.
                        </p>
                    </div>

                </li>
                <li class="list-header">
                    <div id="section3">Information we collect about you.</div>
                    <div class="list-content">
                        <p>
                            Your use of the Dell Technologies Performance Portal (and our Website) will generate
                            information, some of which will relate to you. We may collect and analyse this information,
                            including the following:
                        </p>
                        <br>
                        <ul>
                            <li>
                                technical information, including the Internet protocol (IP) address used to connect your
                                computer to the Internet (an IP address is a unique number assigned to your computer
                                when you are using your browser on the internet), your login information, browser type
                                and version, time zone setting, browser plug-in types and versions, operating system and
                                platform
                            </li>
                            <li>
                                information about your visit to the Dell Technologies Performance Portal website,
                                including the full Uniform Resource Locators (URL) clickstream to, through and from the
                                Website (including date and time), products you viewed or searched for, page response
                                times, download errors, length of visits to certain pages, page interaction information
                                (such as scrolling, clicks, and mouse-overs), and methods used to browse away from the
                                page and any phone number used to call our customer service number
                            </li>
                            <li>
                                information you input into the Dell Technologies Performance Portal or the Website may
                                be used for features including chat rooms, messaging services, and community and event
                                forums for collaboration, peer connection, games, and information exchange purposes.
                                Depending upon the Programme, the personal data you choose to post, share, upload, or
                                make available is public and visible to others who use the Dell Technologies Performance
                                Portal. You should never post or share any information that is confidential or about
                                others unless you have permission to do so. We may use information you provide in
                                community and event profiles and forums to personalise your experience and to make
                                content and peer connection recommendations.
                            </li>
                        </ul>
                        <br>
                        <p>
                            We may also combine your information with information about other people, which will then be
                            aggregated and anonymised. The resulting information, which will not identify you
                            specifically, can
                            be used to help us analyse and improve the Dell Technologies Performance Portal. It may also
                            help us
                            improve our business and may be shared with our customers and suppliers to assist them.
                        </p>
                    </div>

                </li>
                <li class="list-header">
                    <div id="section4">Information we receive from other sources.</div>
                    <div class="list-content">
                        <p>
                            As a Dell Technologies employee, Partner or Authorized Distributor, we will already hold
                            some
                            information about you, and we may combine that with information that we collect in
                            connection
                            with the Dell Technologies Performance Portal.
                        </p>
                        <br>
                        <p>
                            We work closely with third parties (including, other companies in our corporate group,
                            business
                            partners and sub-contractors in technical and delivery services, such as TIC who operate the
                            Website). We share and receive information with these third parties where necessary in order
                            to
                            operate the Dell Technologies Performance Portal.
                        </p>
                        <br>
                        <p>
                            We may collect and process information concerning your employment and participation in the
                            Dell
                            Technologies Performance Portal including, without limitation, details in respect of your
                            ID,
                            training and performance histories, job role, sales performance.
                        </p>
                    </div>

                </li>
                <li class="list-header">
                    <div id="section5">How and why we use your information.</div>
                    <div class="list-content">
                        <p>
                            We need to use your information to operate the Dell Technologies Performance Portal and the
                            Website. This includes using information to the extent required in order to:
                        </p>
                        <br>
                        <ul>
                            <li>
                                allow you to participate in Dell Technologies Performance Portal and assess your
                                eligibility
                                for and, if eligible, inform you about relevant incentives, programmes, products and/or
                                services
                            </li>
                            <li>
                                operate Dell Technologies Performance Portal and the Website (in order to this, we might
                                need to share information with business partners and subcontractors, please section 6
                                for
                                further details)
                            </li>
                            <li>
                                provide you with information about incentives, products, prizes content and services
                                which
                                we believe are relevant to you
                            </li>
                            <li>
                                ensure we provide you with content which is relevant and do so in an effective manner
                            </li>
                            <li>
                                keep track of your Rewards, so you can redeem them
                            </li>
                            <li>
                                As part of the Dell Technologies Performance Portal we require TIC to provide us with
                                reports to analyse the performance of the Programme. This analysis is used to ensure it
                                is
                                working for us and for you. In the course of providing this analysis, it may be
                                necessary
                                for your Personal Data to be analysed and reported back to us. Reports may be produced
                                to
                                show which areas of the Programme are more successful than others to ensure the
                                continued
                                improvement.
                            </li>
                            <li>
                                notify you about changes to the Website, Dell Technologies Performance Portal or our
                                services
                            </li>

                        </ul>
                        <br>
                        <p>
                            <span style="font-weight:600">Employment specific processing:</span>Personal information
                            processed in connection
                            with the Dell Technologies Performance Portal which also relates to your employment
                            (including
                            information regarding the performance your duties as an employee) may be processed by us for
                            employment related purposes. This information could form part of your personnel record as an
                            employee, and could be considered when evaluating the performance of your work. For further
                            information, please see Dell Technologies’ employee handbook.
                        </p>
                        <br>
                        <p>
                            Technical information we collect about your use of the Dell Technologies Performance Portal
                            or
                            the Website may be used for administrative purposes (e.g. maintaining the Website), research
                            and
                            analysis (e.g. to see how many visitors the Website has) and also for the security and
                            maintenance of Dell Technologies Performance Portal and the Website.
                        </p>
                        <br>
                        <p>
                            We use personal information in the manner set out above because we need to in order to:
                        </p>
                        <ul>
                            <li>
                                pursue our legitimate interests in operating the Dell Technologies Performance Portal
                                and
                                providing incentives to individuals (provided this isn’t be overridden by your rights)
                            </li>
                            <li>
                                Enter into, or perform, a contract with you
                            </li>
                            <li>
                                Comply with a legal duty
                            </li>
                            <li>
                                Protect your vital interests
                            </li>

                        </ul>
                        <br>
                        <p>
                            We may also use information with your consent, but we will make it clear when we do this. In
                            any
                            event, your information will only be used for the purpose(s) we collected it for (or else
                            for a
                            closely related purpose, such as record keeping).
                        </p>
                        <br>
                        <p>
                            If you enrol on the Website and participate in the Dell EMC Performance Portal we may send
                            you
                            work e-mails about the Dell Technologies Performance Portal, its features and services from
                            time
                            to time. These e-mails will only be directly related to the Dell Technologies Performance
                            Portal
                            and your participation in it.
                        </p>
                    </div>
                </li>
                <li class="list-header">
                    <div id="section6">Disclosure of Your Information.</div>
                    <div class="list-content">
                        <p>
                            We respect the privacy of your information and won’t share it with third parties, except in
                            a
                            few cases where necessary for the purposes set out above. The recipients of your information
                            may
                            include:
                        </p>
                        <br>
                        <ul>
                            <li>Other companies within our corporate group</li>
                            <li>Suppliers and sub-contractors</li>
                            <li>providers of analytics services, who help us improve and optimise the Website.</li>
                        </ul>
                        <br>
                        <p>
                            Where we share personal information with a third party, we will take steps to ensure that
                            your
                            data is properly protected.
                        </p>
                        <br>
                        <p>
                            One of the subcontractors we share information with is The Incentive Company (TIC), which
                            administers the Dell Technologies Performance Portal and operates the Website for us. Any
                            information you provide via the Website will be processed by TIC on our behalf, but there
                            will
                            be a contract in place to ensure your information and rights are protected.
                        </p>
                        <br>
                        <p>
                            In addition to the situations above, we may share information if the need arises because:
                        </p>
                        <br>
                        <ul>
                            <li>
                                we are involved in a takeover or merger with another business (and, in these situations,
                                data about the Dell Technologies Performance Portal and its participants may be one of
                                the
                                assets which is transferred)
                            </li>
                            <li>
                                we are under a legal duty to disclose your information (for example, we are required by
                                law
                                enforcement or a court order)
                            </li>
                            <li>
                                the sharing is required in order for us or a third party (including TIC) to enforce a
                                contract (including the terms of the Dell Technologies Performance Portal and/or the
                                Reward
                                Scheme)
                            </li>
                            <li>
                                to protect the rights, property, or safety of Dell Technologies, the participants of the
                                Dell Technologies Performance Portal, or others.
                            </li>
                        </ul>
                    </div>
                </li>
                <li class="list-header">
                    <div id="section7">Where We Store Your Personal Data.</div>
                    <div class="list-content">
                        <p>
                            We normally only store personal information within the European Economic Area (EEA). In the
                            event that we do have to transfer your personal information outside of the EEA then we will
                            take
                            steps to make sure adequate levels of privacy protection, in line with UK data protection
                            law,
                            are in place. These safeguards will usually be contractual and/or the result of a European
                            Union
                            decision which allows the transfer (for example, a US organization which is certified under
                            the
                            EU-US Privacy Shield framework).
                        </p>
                        <br>
                        <p>
                            All information you provide to us is stored on our secure servers. Where you have been
                            provided
                            with (or where you have chosen) a password which enables you to access the Website, you are
                            responsible for keeping this password confidential. We ask you not to share a password with
                            anyone.
                        </p>
                        <br>
                        <p>
                            Unfortunately, the transmission of information via the internet is not completely secure and
                            even the best policy cannot protect your online privacy and security in all circumstances.
                            We
                            will do our best to protect your personal data however, we cannot guarantee the security of
                            your
                            data transmitted to the Website. Any transmission is at your own risk. Once we have received
                            your information, we will use strict procedures and security features to try to prevent
                            unauthorised access.
                        </p>
                    </div>
                </li>
                <li class="list-header">
                    <div id="section8">How long we store your information for.</div>
                    <div class="list-content">
                        <p>
                            We only store personal information so long as it is required for the purpose(s) we it
                            collected
                            for (or for a related compatible purpose, such as keeping a record of a transaction). We
                            regularly review what data we have and delete that which is no longer necessary. In certain
                            situations you have the right to request that your data be deleted (the right to be
                            forgotten),
                            please see section 10 for further details.
                        </p>
                    </div>
                </li>
                <li class="list-header">
                    <div id="section9">Cookies.</div>
                    <div class="list-content">
                        <p>
                            A cookie, also known as an HTTP cookie, web cookie, or browser cookie, is a small piece of
                            data
                            sent from a website and stored in a users' web browser while a user is browsing a website.
                        </p>
                        <br>
                        <p>
                            The Website uses cookies to distinguish you from other users of the Website and to deliver
                            to
                            you your individual view of the Dell Technologies Performance Portal. This helps us to
                            provide
                            you with a good experience when you browse the Website and also allows us to improve the
                            Website. For detailed information on the cookies we use and the purposes for which we use
                            them
                            see our Cookie Policy.
                        </p>
                    </div>

                </li>
                <li class="list-header">
                    <div id="section10">How long we store your information for.</div>
                    <div class="list-content">
                        <p>
                            We respect your right to access and control your information. Part of this is making sure
                            you
                            understand your legal rights, which are as follows:
                        </p>
                        <br>
                        <ul>
                            <li>
                                the right of access to your personal data, we will happily respond to requests for
                                information and, where applicable, will correct, amend or delete your personal data.
                                These
                                requests are subject to any relevant legal requirements and exemptions, including
                                identity
                                verification procedures. Before providing data to you, we will ask for proof of identity
                                and
                                sufficient information about your interaction with us so that we can locate any relevant
                                data;
                            </li>
                            <li>
                                the right to have certain information provided to you in a portable electronic format,
                                or
                                transmitted to another data controller, where technically feasible;
                            </li>
                            <li>
                                the right to have inaccurate data rectified, please remember that you can update your
                                account information by using the “Contact Us” option on the Dell Technologies
                                Performance
                                Portal;
                            </li>
                            <li>
                                the right to object to your data being used for our or a third party’s legitimate
                                interests,
                                or for direct marketing purposes;
                            </li>
                            <li>
                                The right not to be subject to automated decision making and profiling;
                            </li>
                            <li>
                                The right to restrict how your personal information is used;
                            </li>
                            <li>
                                the right to be forgotten, which allows you to have your data erased in certain
                                circumstances, we will always consider all requests in accordance with the ICO guidance
                                and
                                relevant laws and will always balance your interests with the following areas where it
                                is
                                necessary to retain your data :
                                <ul>
                                    <li>
                                        to exercise the right of freedom of expression and information;
                                    </li>
                                    <li>
                                        to comply with a legal obligation for the performance of a public interest task
                                        or
                                        exercise of official authority.
                                    </li>
                                    <li>
                                        the exercise or defence of legal claims
                                    </li>
                                </ul>
                            </li>
                        </ul>
                        <br>
                        <p>
                            If you would like further information on your rights or wish to exercise them, please email
                            privacy@dell.com with details of your request.
                        </p>
                        <br>
                        <p>
                            Please keep in mind that there are exceptions to the rights above and, though we will always
                            try
                            to respond to your satisfaction, there may be situations where we are unable to do so (for
                            example, because the information no longer exists or there is an exception which applies to
                            your
                            request).
                        </p>
                        <br>
                        <p>
                            If you are not happy with our response, or you believe that your data protection or privacy
                            rights have been infringed, you should contact the UK Information Commissioner's Office,
                            which
                            oversees data protection compliance in the UK. Details of how to do this can be found at
                            www.ico.org.uk.
                        </p>
                    </div>

                </li>
                <li class="list-header">
                    <div id="section11">Changes to Our Privacy Policy.</div>
                    <div class="list-content">
                        <p>
                            Any changes we may make to this Privacy Policy in the future will be posted on this page
                            and,
                            where appropriate, notified to you by e-mail. Please check back frequently to see any
                            updates or
                            changes to this Privacy Policy.
                        </p>
                    </div>
                </li>
                <li class="list-header">
                    <div id="section12">Contact.</div>
                    <div class="list-content">
                        <p>
                            Questions, comments and requests regarding this Privacy Policy are welcomed and should be
                            addressed
                            to
                            privacy@dell.com
                        </p>
                    </div>
                </li>
            </ol>
        </div>

    </div>
</template>

<script setup>

</script>

<style>
.list-item-border {
    list-style-position: inside;
    border-bottom: 1px solid #CFD8DC;
    padding: 10px;
}

.list-item-anchor {
    text-decoration: none;
    color: #055699;
    font-weight: 300;
    font-size: 16px;
}

html {
    scroll-behavior: smooth;
}
</style>